import { BrowserRouter } from 'react-router-dom';
import Footer from './Footer';

function App() {
	return (
		<BrowserRouter>
			<Footer />
		</BrowserRouter>
	);
}

export default App;
